// Centralized utilities for ProVet onboarding params

const LS_CLIENT = 'provet_client';
const LS_USER = 'provet_user';
const LS_TS = 'provet_timestamp';
const LS_VER = 'provet_verify';

export function getProvetParamsFromSearch(search = '') {
    try {
        const sp = new URLSearchParams(search || '');
        const client = sp.get('client') || null;
        const user = sp.get('user') || null;
        const timestamp = sp.get('timestamp') || null;
        const verification = sp.get('verification') || null;
        return { client, user, timestamp, verification };
    } catch {
        return { client: null, user: null, timestamp: null, verification: null };
    }
}

export function persistProvetParams({ client, user, timestamp, verification }) {
    if (client) localStorage.setItem(LS_CLIENT, client);
    if (user) localStorage.setItem(LS_USER, user);
    if (timestamp) localStorage.setItem(LS_TS, timestamp);
    if (verification) localStorage.setItem(LS_VER, verification);
}

export function getProvetParamsFromStorage() {
    return {
        client: localStorage.getItem(LS_CLIENT),
        user: localStorage.getItem(LS_USER),
        timestamp: localStorage.getItem(LS_TS),
        verification: localStorage.getItem(LS_VER),
    };
}

export function isProvetOnboarding({ search } = {}) {
    const q = getProvetParamsFromSearch(search);
    const s = getProvetParamsFromStorage();
    return Boolean(
        q.client || q.user || q.timestamp || q.verification || s.client || s.user || s.timestamp || s.verification,
    );
}

// Build query string by merging base params with ProVet params (from search by default; falls back to storage)
export function buildQuery(baseParams = {}, { search, useStorageFallback = true } = {}) {
    const fromSearch = getProvetParamsFromSearch(search);
    const provet = { ...fromSearch };

    if (useStorageFallback) {
        const fromLS = getProvetParamsFromStorage();
        provet.client = provet.client || fromLS.client;
        provet.user = provet.user || fromLS.user;
        provet.timestamp = provet.timestamp || fromLS.timestamp;
        provet.verification = provet.verification || fromLS.verification;
    }

    const qs = new URLSearchParams({
        ...baseParams,
        ...(provet.client ? { client: provet.client } : {}),
        ...(provet.user ? { user: provet.user } : {}),
        ...(provet.timestamp ? { timestamp: provet.timestamp } : {}),
        ...(provet.verification ? { verification: provet.verification } : {}),
    }).toString();

    return qs ? `?${qs}` : '';
}

// Create integrations payload fragment for backend if ProVet params present (from storage)
export function makeProvetIntegrationsPayload() {
    const { user, timestamp, verification } = getProvetParamsFromStorage();
    if (user || timestamp || verification) {
        return {
            integrations: {
                provet: {
                    userId: user || null,
                    timestamp: timestamp || null,
                    verification: verification || null,
                },
            },
        };
    }
    return null;
}
